export const MCC_GROUP = {
    GROCERIES: 'groceries',
    CAFES: 'cafes',
    TRANSPORT: 'transport',
    HEALTH: 'health',
    CLOTHING: 'clothing',
    ENTERTAINMENT: 'entertainment',
    HOME: 'home',
    UTILITIES: 'utilities',
    KIDS: 'kids',
    PETS: 'pets',
    TRAVEL: 'travel',
    TRANSFERS: 'transfers',
    CASH: 'cash',
    OTHER: 'other',
};
export const MCC_GROUPING_REVISION = 1;
export const UTILITY_MCCS = [4900];
export const TRANSFER_MCCS = [4829, 6012, 6051, 6211, 6536, 6537, 6538, 6540];
const MCC_RANGES = [
    { from: 3000, to: 3999, group: MCC_GROUP.TRAVEL },
    { from: 5811, to: 5814, group: MCC_GROUP.CAFES },
    { from: 8011, to: 8099, group: MCC_GROUP.HEALTH },
];
const MCC_CODES = [
    { group: MCC_GROUP.GROCERIES, codes: [5411, 5422, 5441, 5451, 5462, 5499, 5921] },
    {
        group: MCC_GROUP.TRANSPORT,
        codes: [4111, 4121, 4131, 4784, 4789, 5511, 5521, 5533, 5541, 5542, 7523, 7531, 7538, 7542],
    },
    {
        group: MCC_GROUP.HEALTH,
        codes: [4119, 5047, 5122, 5912, 5975, 5976, 5977, 7230, 7297, 7298],
    },
    {
        group: MCC_GROUP.CLOTHING,
        codes: [
            5131, 5137, 5139, 5611, 5621, 5631, 5651, 5655, 5661, 5681, 5691, 5697, 5698, 5699, 5948,
        ],
    },
    {
        group: MCC_GROUP.ENTERTAINMENT,
        codes: [
            4899, 5733, 5735, 5815, 5816, 5817, 5818, 5941, 7829, 7832, 7841, 7922, 7929, 7932, 7933,
            7941, 7991, 7992, 7993, 7994, 7996, 7997, 7998, 7999,
        ],
    },
    {
        group: MCC_GROUP.HOME,
        codes: [
            1520, 1711, 1731, 1740, 1750, 1761, 1771, 4812, 4814, 4816, 5045, 5065, 5072, 5200, 5211,
            5231, 5251, 5261, 5310, 5331, 5712, 5713, 5714, 5718, 5719, 5722, 5732, 5950, 5983, 7342,
            7349, 7623, 7629, 7641,
        ],
    },
    { group: MCC_GROUP.UTILITIES, codes: UTILITY_MCCS },
    { group: MCC_GROUP.KIDS, codes: [5641, 5945, 8351] },
    { group: MCC_GROUP.PETS, codes: [742, 5995] },
    {
        group: MCC_GROUP.TRAVEL,
        codes: [4112, 4411, 4511, 4582, 4722, 7011, 7012, 7032, 7033, 7512],
    },
    { group: MCC_GROUP.TRANSFERS, codes: TRANSFER_MCCS },
    { group: MCC_GROUP.CASH, codes: [6010, 6011] },
];
const isInRange = (mcc, range) => mcc >= range.from && mcc <= range.to;
export const groupOfMcc = (mcc) => {
    const range = MCC_RANGES.find((candidate) => isInRange(mcc, candidate));
    if (range !== undefined) {
        return range.group;
    }
    const listed = MCC_CODES.find((entry) => entry.codes.includes(mcc));
    return listed?.group ?? MCC_GROUP.OTHER;
};
export const EVERYDAY_MCC_GROUPS = [
    MCC_GROUP.GROCERIES,
    MCC_GROUP.CAFES,
    MCC_GROUP.TRANSPORT,
    MCC_GROUP.HEALTH,
];
export const isEverydayMcc = (mcc) => EVERYDAY_MCC_GROUPS.includes(groupOfMcc(mcc));
export const TELECOM_MCCS = [4814];
export const isTelecomMcc = (mcc) => TELECOM_MCCS.includes(mcc);
//# sourceMappingURL=mcc-groups.js.map